module.exports = "<p>\n  widg-session-calendar works!\n</p>\n"